import type { ModelData } from '../../types'

export const dragonPolokragle: { [key: string]: ModelData } = {
  'dragon-8r': {
    id: 'dragon-8r',
    name: 'Dragon 8R',
    power: '11 kW',
    type: 'powietrzny nofusion',
    glassType: 'polokragla' as const,
    image: 'images/dragon-8r.jpg',
    emailSubject: 'Zapytanie - Dragon 8R',
    description: 'Wkład powietrzny półokrągły 11 kW',
    basePrices: {
      standard: { single: 7710 }
    },
    extraPrices: {
      ceramic: {
        'refrabox-light': 0,
        'cerabox-graphite': 0
      },
      handle: {
        'classic-black': 0,
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: {
          'none': 0,
          'flush-15': 390,
          'flush-30': 390,
          'recessed-15': 0,
          'recessed-30': 0,
          'recessed-15-45': 0
        }
      },
      fusion: {
        'none': 0,
        'fusion': 500,
        'fusion-modules': 200
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    labels: {
      variant: { 
        'standard': 'Standard' 
      },
      glass: { 
        'single': 'Szyba półokrągła R330' 
      },
      ceramic: {
        'refrabox-light': 'Jasna Refrabox',
        'cerabox-graphite': 'Grafitowa Cerabox'
      },
      handle: {
        'classic-black': 'Classic czarna',
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: {
        'none': 'Bez blendy',
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: {
        'none': 'Bez fusion',
        'fusion': 'Fusion Basic',
        'fusion-modules': 'Fusion Modules'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    specs: {
      power: '11 kW',
      glassSize: 'R330',
      width: '742 mm',
      height: '742 mm',
      depth: '460 mm',
      weight: '150 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - Dragon 8R',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego Dragon 8R w konfiguracji:\n\nModel: Dragon 8R\nMoc: 11 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'

    }
  }
}
